import { AppState } from 'Store'

const getAll = (state: AppState) => state.adminSlice.fakeResponsesSlice.krDrsFakeResponses.data
const getRequestParams = (state: AppState) =>
	state.adminSlice.fakeResponsesSlice.krDrsFakeResponses.requestParams
const getChosenItem = (state: AppState) =>
	state.adminSlice.fakeResponsesSlice.krDrsFakeResponses.chosenItem

export const krDrsFakeResponsesSelectors = {
	getAll,
	getRequestParams,
	getChosenItem,
}
